/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ChangeKpiStatusCommand } from '../../models/change-kpi-status-command';
import { ChangeKpiStatusCommandResult } from '../../models/change-kpi-status-command-result';

export interface ApiKpiReportsChangeKpiStatusPost$Params {
      body?: ChangeKpiStatusCommand
}

export function apiKpiReportsChangeKpiStatusPost(http: HttpClient, rootUrl: string, params?: ApiKpiReportsChangeKpiStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ChangeKpiStatusCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsChangeKpiStatusPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ChangeKpiStatusCommandResult>;
    })
  );
}

apiKpiReportsChangeKpiStatusPost.PATH = '/api/KPIReports/ChangeKPIStatus';
